import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import PageStructure from 'flarum/forum/components/PageStructure';
import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import RankingImage from './RankingImage';

/**
 * This page re-uses Flarum's IndexPage CSS classes
 */
export default class RankingsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('canViewRankingPage')) {
      m.route.set('/');
    }
    this.loading = true;
    this.users = [];
    this.refresh();
  }
  view() {
    let loading;
    if (this.loading) {
      loading = LoadingIndicator.component();
    } else {
      loading = Button.component({
        className: 'Button',
        onclick: this.loadMore.bind(this)
      }, app.translator.trans('core.forum.discussion_list.load_more_button'));
    }
    return m(PageStructure, {
      className: "RankingsPage",
      hero: () => IndexPage.prototype.hero(),
      sidebar: () => m(IndexSidebar, null)
    }, m("table", {
      class: "rankings"
    }, m("tr", null, m("th", {
      className: "rankings-mobile"
    }, app.translator.trans('fof-gamification.forum.ranking.rank')), m("th", null, app.translator.trans('fof-gamification.forum.ranking.name')), m("th", null, app.translator.trans('fof-gamification.forum.ranking.amount'))), this.users.map((user, i) => {
      ++i;
      return [m("tr", {
        className: 'ranking-' + i
      }, i < 4 ? m(RankingImage, {
        place: i
      }) : m("td", {
        className: "rankings-4 rankings-mobile"
      }, this.addOrdinalSuffix(i)), m("td", null, m("div", {
        className: "PostUser"
      }, m("div", {
        className: "PostUser-name rankings-info"
      }, m(Link, {
        href: app.route.user(user),
        force: true
      }, i < 4 ? m(Avatar, {
        user: user,
        className: 'info-avatar rankings-' + i + '-avatar'
      }) : '', " ", username(user))))), i < 4 ? m("td", {
        className: 'rankings-' + i
      }, user.points()) : m("td", {
        className: "rankings-4"
      }, user.points()))];
    })), m("div", {
      className: "rankings-loadmore"
    }, " ", loading));
  }
  refresh(clear) {
    if (clear === void 0) {
      clear = true;
    }
    if (clear) {
      this.loading = true;
      this.users = [];
    }
    return this.loadResults().then(results => {
      this.users = [];
      this.parseResults(results);
    }, () => {
      this.loading = false;
      m.redraw();
    });
  }
  addOrdinalSuffix(i) {
    if (app.data.locale === 'en') {
      const j = i % 10;
      const k = i % 100;
      if (j === 1 && k !== 11) {
        return i + 'st';
      } else if (j === 2 && k !== 12) {
        return i + 'nd';
      } else if (j === 3 && k !== 13) {
        return i + 'rd';
      }
      return i + 'th';
    } else {
      return i;
    }
  }
  loadResults(offset) {
    const params = {};
    params.page = {
      filter: {
        rankable: true
      },
      include: 'ranks',
      sort: '-votes',
      offset: offset,
      limit: '10'
    };
    return app.store.find('users', params);
  }
  loadMore() {
    this.loading = true;
    this.loadResults(this.users.length).then(this.parseResults.bind(this));
  }
  parseResults(results) {
    [].push.apply(this.users, results);
    this.loading = false;
    this.users.sort(function (a, b) {
      return parseFloat(b.points()) - parseFloat(a.points());
    });
    m.redraw();
    return results;
  }
}
flarum.reg.add('fof-gamification', 'forum/components/RankingsPage', RankingsPage);